import { render, staticRenderFns } from "./keepPrice.vue?vue&type=template&id=8a8ff762&scoped=true"
import script from "./keepPrice.vue?vue&type=script&lang=js"
export * from "./keepPrice.vue?vue&type=script&lang=js"
import style0 from "./keepPrice.vue?vue&type=style&index=0&id=8a8ff762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8ff762",
  null
  
)

export default component.exports